exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cashboxbutton[data-v-38718e86]{bottom:15px;position:fixed;z-index:38;right:15px;box-shadow:5px 0 13px 3px rgba(0,0,0,.1);border-radius:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-38718e86","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/registrar/Registrar.vue
// module id = 497
// module chunks = 0